import { useState, useCallback } from "react";
import Constants from '../Constants';
import useAxios from "../hooks/useAxios";
import { toaster } from "../utils/toast";

const useCaseData = ({ caseId, apiUrl = Constants.ApiUrl.case.getCaseById } = {}) => {
  const [caseData, setCaseData] = useState(null);
  const { getData, isLoading } = useAxios();

  const fetchCaseData = useCallback(async () => {
    if (!caseId) return null;
    try {
      const response = await getData(`${apiUrl}/${caseId}`);
      if (!response.success) {
        toaster({ message: response.message, success: response.success });
        return null;
      }
      setCaseData(response?.data);
      return response?.data;
    } catch (error) {
      console.error("Error fetching case data:", error);
      return null;
    }
  }, [apiUrl, caseId, getData]);

  return { fetchCaseData, caseData, isLoading };
};

export default useCaseData;